import { get } from '@/utils/request';

export const invoices = (params) => {
  return get('/api/v1/invoices', params);
};
export const invoice_statuss = (params) => {
  return get('/api/v1/invoice_statuss', params);
};
